import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Subject, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { SseClient } from 'ngx-sse-client';

const assessment = 'case';
const apiRoutes = {
	assessment: assessment,
  signedURL: assessment + '/get-upload-url',
}

@Injectable({ providedIn: 'root' })
export class ActivityService {
  private uploadStatusSubject = new Subject<string>();
  private progressActivityData = new Subject<{ data: any, progress: number }>();
	withCredentials = { withCredentials: true };

	sseSubscription!: Subscription;
	progress_check = 0;

  constructor(private http: HttpClient, private sseClient: SseClient, private authService: AuthService) { }

  getUploadStatusSubject() {
    return this.uploadStatusSubject.asObservable();
  }

  getProgressActivityData() {
    return this.progressActivityData.asObservable();
  }

	async updateActivityStatus(project_id: number, case_id: number, activity_id: number, params: any, data: any) {
		const response$ = this.http.patch<any>(environment.api + apiRoutes.assessment + '/' + project_id + '/' + case_id + '/' + activity_id, data, { params: params });
		const response = await firstValueFrom(response$);
		return response;
	}

  uploadActivityFile = async (storage_route: string, file: File, onProgress: (loadedBytes: number, totalBytes: number) => void, abortSignal?: AbortSignal) => {
		const fileName = `${storage_route}/${file.name}`;
		const signedUrl = await this.getSignedUrl(fileName, file.type);

		const xhr = new XMLHttpRequest();
		xhr.open('PUT', signedUrl, true);
		xhr.setRequestHeader('Content-Type', file.type);

		xhr.upload.onprogress = (event) => {
			if (event.lengthComputable) {
				if (abortSignal && abortSignal.aborted) {
					xhr.abort();
					return;
				}

				onProgress(event.loaded, event.total);
			}
		};

		xhr.onload = () => {
			this.uploadStatusSubject.next('complete');
		};

		xhr.onerror = async () => {
			this.uploadStatusSubject.next('error');
		};

		xhr.onabort = () => {
			this.uploadStatusSubject.next('abort');
		};

		xhr.send(file);
	}

  async getSignedUrl(file_name: string, file_type: string): Promise<any> {
    const response$ = this.http.post<any>(environment.api + apiRoutes.signedURL, { file_name, file_type });
    const response = await firstValueFrom(response$);
    return response;
  }

	getProjectActivityData(project_id: number, case_id: number, activity_id: number) {
		const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.authService.token}`, 'client_id': this.authService.clientID });
		const url = environment.api + apiRoutes.assessment + '/data/' + project_id + '/' + case_id + '/' + activity_id;
		this.sseSubscription = this.sseClient.stream(url, { keepAlive: false, reconnectionDelay: 0, responseType: 'event' }, { headers, withCredentials: true }, 'GET').subscribe(
			(event) => {
				const messageEvent = event as MessageEvent;

				if (event.type === 'error') {
					if (this.progress_check < 100) {
						// send the option to retry;
					}
					this.sseSubscription.unsubscribe();
				}

				if (!messageEvent.data) {
					this.sseSubscription.unsubscribe();
				} else {
					const data = JSON.parse(messageEvent.data);
					if (data.progress) {
						this.progress_check = data.progress;
						this.progressActivityData.next({ data: data.message, progress: data.progress });
					}
				}
			}
		);
	}
}